import { useStateLocalStorage } from "@dotlegal/dotlegal-ui-components";

export function useDismissable(storageKey: string, reshowAfterDays: number, shouldShow: boolean) {
    const [dismissedAt, setDismissedAt] = useStateLocalStorage<number | undefined>(storageKey, undefined);

    let visible = shouldShow;
    if (dismissedAt) {
        const daysSinceDismissed = (Date.now() - dismissedAt) / 1000 / 60 / 60 / 24;
        visible = daysSinceDismissed >= reshowAfterDays && shouldShow;
    }

    function onDismiss() {
        setDismissedAt(Date.now());
    }

    return { visible, onDismiss };
}
